<input-text>
    <div>
        <label if="{ props.label }" for="{ props.ckey }" class="block text-sm/6 font-medium text-gray-900">{ props.label }</label>
        <div class="{ props.label ? 'mt-2' : '' }">
            <input 
                step="{ props.step }" 
                autocomplete="{ props.autocomplete }" 
                placeholder="{ props.placeholder }" 
                required="{ props.is_required }" 
                disabled="{ props.is_disabled }" 
                type="{ props.inputtype ? props.inputtype : 'text' }" 
                name="{ props.ckey }" 
                id="{ props.ckey }" 
                value="{ props.value ? props.value : '' }" 
                oninput="{ edit }"
                class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6">
        </div>
        <p if="{ props.show_help }" class="mt-3 text-sm/6 text-gray-600"><slot/></p>
    </div>
    
    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {
                this.state = {
                    value: ''
                }
                eventBus.on(EVENTS.INPUT.UPDATE, this.handleUpdateInput)
                eventBus.on(EVENTS.INPUT.RESET, this.handleResetInput)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.INPUT.UPDATE, this.handleUpdateInput)
                eventBus.off(EVENTS.INPUT.RESET, this.handleResetInput)
            },

            edit(e) {
                this.update({
                    value: e.target.value
                })
                eventBus.trigger(EVENTS.INPUT.UPDATED, {
                    ckey: this.props.ckey,
                    value: e.target.value
                })
            },

            handleUpdateInput(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        value: e.value
                    })
                }
            },

            handleResetInput(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        value: ''
                    })
                    this.$("input").value = ""
                    eventBus.trigger(EVENTS.INPUT.UPDATED, {
                        ckey: this.props.ckey,
                        value: ''
                    })
                }
            },
        }
    </script>
</input-text>